import { Repository } from 'app/services/database/repository';
import { UserModel } from 'app/views/user/models/user.model';

export class UserRepository extends Repository<UserModel> {
    protected get path() { return '/users/'; }
}



// WEBPACK FOOTER //
// ./src/app/services/database/user.repository.ts